import { constantRoutes, asyncRoutes } from "@/router"
import { getRoutes } from "@/api/user.js"
import { mappingPath } from "@/router/index.js"
import router from "@/router/index.js"
import Cookies from "js-cookie"
const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

function initRoutes(menu) {
  if (menu.length == 0) {
    return
  }
  let menus = formatRoutes(menu)
  let unfound = { path: "*", redirect: "/404", hidden: true }
  menus.push(unfound)
  router.addRoute(menus)
  commit("SET_ROUTES", menus)
}

function formatRoutes(aMenu) {
  let _language = window.sessionStorage.getItem("lang_IAP")
  if (_language == "zh" || _language == null) {
    const routes = []
    aMenu.forEach((item) => {
      let myRoute = mappingPath[item.Item.Url]
      if (myRoute) {
        myRoute.meta = { title: item.Item.Name, icon: item.Item.IconName, moduleId: item.Item.Id }
        myRoute.children = item.Children && item.Children.length ? formatRoutes(item.Children) : []
        routes.push(myRoute)
      }
    })
    return routes
  } else {
    const routes = []
    aMenu.forEach((item) => {
      let myRoute = mappingPath[item.Item.Url]
      if (myRoute) {
        myRoute.meta = { title: item.Item.EnglishName, icon: item.Item.IconName, moduleId: item.Item.Id }
        myRoute.children = item.Children && item.Children.length ? formatRoutes(item.Children) : []
        routes.push(myRoute)
      }
    })
    return routes
  }
}

const actions = {
  getRoutes({ commit }) {
    getRoutes()
      .then((res) => {
        let menu = res.dt
        if (menu.length == 0) {
          return
        }
        let menus = formatRoutes(menu)
        // let menus = [];
        let unfound = { path: "*", redirect: "/404", hidden: true }
        menus.push(unfound)
        router.addRoutes(menus)
        commit("SET_ROUTES", menus)

        var shortMenus = new Array()
        menu.forEach((item) => {
          item.Children.forEach((child) => {
            shortMenus.push({ id: child.Item.Id, url: child.Item.Url })
          })
        })
        Cookies.set("usermenus", JSON.stringify(shortMenus))
      })
      .catch((error) => {})
  },
  getMenuId(shortMenus, children) {
    children.forEach((child) => {
      shortMenus.push({ id: item.Id, url: item.Url })
    })
    return
  },

  generateRoutes({ commit }, roles) {
    return new Promise((resolve) => {
      let accessedRoutes
      if (roles.includes("admin")) {
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      commit("SET_ROUTES", accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach((route) => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
